import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { MicrosoftGraph } from "@graylog/enterprise-api";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import formValidation from "../common/utils/formValidation";
import { renderOptions } from "../common/Options";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { connectionString } = formData;
  const subscriptions = [
    { label: t("common.subscription.global_service"), value: "GLOBAL" },
    { label: t("common.subscription.us_government"), value: "US_GOV" },
    { label: t("common.subscription.us_dod"), value: "US_DOD" }
  ];
  const handleSubmit = () => {
    var _a, _b, _c, _d;
    const fetcher = MicrosoftGraph.checkCredentials({
      tenant_id: ((_a = formData == null ? void 0 : formData.tenantId) == null ? void 0 : _a.value) || "",
      client_id: ((_b = formData == null ? void 0 : formData.clientId) == null ? void 0 : _b.value) || "",
      client_secret: ((_c = formData == null ? void 0 : formData.clientSecret) == null ? void 0 : _c.value) || "",
      subscription_type: ((_d = formData == null ? void 0 : formData.subscriptionType) == null ? void 0 : _d.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("microsoftgraph.errors.unable_to_connect")
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: t("microsoftgraph.errors.unable_to_connect")
      });
    });
  };
  const isFormValid = formValidation.isFormValid(
    ["graphName", "tenantId", "clientId", "clientSecret", "subscriptionType"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      className: "col-md-7",
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "graphName",
        type: "text",
        fieldData: formData.graphName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "tenantId",
        type: "text",
        fieldData: formData.tenantId,
        onChange,
        label: t("microsoftgraph.authorize.tenant_id"),
        help: t("microsoftgraph.authorize.tenant_id_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        label: t("microsoftgraph.authorize.client_id"),
        help: t("microsoftgraph.authorize.client_id_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientSecret",
        type: "password",
        onChange,
        fieldData: formData.clientSecret,
        label: t("microsoftgraph.authorize.client_secret"),
        help: t("microsoftgraph.authorize.client_secret_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        name: "subscriptionType",
        id: "subscriptionType",
        onChange,
        fieldData: formData.subscriptionType,
        help: t("common.subscription.type_help"),
        required: true,
        label: t("common.subscription.type")
      },
      renderOptions(subscriptions, t("common.subscription.choose"))
    )
  );
};
export default StepAuthorize;
